<template>
    <div class="custom bg-[#23242A]">
        <div class="flex xl:flex-row flex-col px-4 pt-4 bg-[#23242A] text-white">
            <div class="transition-all duration-100 ease-linear custom-left mr-2 w-full" :class="(add || edit)?'xl:w-[40%] w-full':'w-full'">
                <component :is="listType.component" @togglePurchaseOrderUploadPop="togglePurchaseOrderUploadPop" />
            </div>
            <PurchaseOrderUploadPop v-if="purchaseOrderUploadPop" @close="closePurchaseOrderUpload" @uploadedPayload="uploadedPayload" />
        </div>
    </div>
</template>
<script>
import { defineComponent, ref} from 'vue'
import PurchaseOrderList from '@/views/Products/PurchaseOrder/PurchaseOrder/PurchaseOrderListV2.vue'
import PurchaseOrderUploadPop from '@/views/Products/Product/List/OrderUploadPop.vue'

export default defineComponent({
    components: {
        PurchaseOrderList,
        PurchaseOrderUploadPop
    },
    setup() {
        // list 
        const listType = ref({
            component: 'PurchaseOrderList', 
        })

        // poup
        const purchaseOrderUploadPop = ref(false)

        return {listType, purchaseOrderUploadPop}
    },
    methods: {
        // purchase order upload
        togglePurchaseOrderUploadPop(status){
            this.purchaseOrderUploadPop = status
        },
        closePurchaseOrderUpload(){
            this.purchaseOrderUploadPop = false
        },
        uploadedPayload(payload){
            if(payload?.data?.payload?.id){
                this.closePurchaseOrderUpload()
                this.$router.push({name: 'AddPurchaseOrders', params: {id: payload.data.payload.id}})
            }
        }
    }
})
</script>